import React from 'react'
import UserAvatar from '../../Navbar/UserAvatar'
import styles from './SenderMessageCard.module.scss'
import { MediaIcon } from '../../../assets/icons/media-icon'
function SenderMessageCard({
    messageInfo, // this will contain time, message content
    containFile = false
}) {
    return (
        <div>
            <div className={styles.message_info_container}>
                <div className={styles.sender_avatar}>
                    <UserAvatar width={20} height={20} />
                </div>
                <div className={styles.message_container}>
                    <div className={styles.message_sender_and_time_container}>
                        <div className={styles.sender_name}>
                            Phoenix Baker
                        </div>
                        <div className={styles.message_time}>
                            Friday 2:20pm
                        </div>
                    </div>
                    {containFile ?
                        <div className={styles.file_container}>
                            <div className={styles.file_icon}>
                                <MediaIcon />
                            </div>
                            <div className={styles.file_name_size_container}>
                                <div className={styles.file_name}>Latest design screenshot.jpg</div>
                                <div className={styles.file_size}>1.2 MB</div>
                            </div>
                        </div> :
                        <div className={styles.message}>
                            Hey Olivia, can you please review the latest design when you can?
                        </div>}
                </div>
            </div>
        </div>
    )
}

export default SenderMessageCard